
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clickdealer-alternative",
      function () {
        return require("private-next-pages/clickdealer-alternative.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clickdealer-alternative"])
      });
    }
  